/**
 * @param markup {string}
 * @return {Element}
 * @throws {Error}
 */
module.exports = function runHtml(markup) {
  const div = document.createElement("div");
  div.innerHTML = markup;

  const child = div.firstElementChild;

  if (child) {
    return child;
  } else {
    throw new Error("Invalid HTML");
  }
};
